/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Portfolio_Not_ReadyInputs */

const en_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up your portfolio before depositing.`)
};

const de_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richten Sie Ihr Portfolio ein, bevor Sie einzahlen.`)
};

const pt_br2_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure seu portfólio antes de depositar.`)
};

const tr_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para yatırmadan önce portföyünüzü kurun.`)
};

const zh_cn2_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先设置您的投资组合，然后再存入。`)
};

const zh_hk2_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請先設定你的投資組合，然後再存入。`)
};

const ko_kr2_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입금하기 전에 포트폴리오를 설정하세요.`)
};

const ru_ru2_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте портфель, прежде чем вносить средства.`)
};

const es_419_deposit_error_portfolio_not_ready = /** @type {(inputs: Deposit_Error_Portfolio_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura tu portafolio antes de depositar.`)
};

/**
* | output |
* | --- |
* | "Set up your portfolio before depositing." |
*
* @param {Deposit_Error_Portfolio_Not_ReadyInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_portfolio_not_ready = /** @type {((inputs?: Deposit_Error_Portfolio_Not_ReadyInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Portfolio_Not_ReadyInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_portfolio_not_ready(inputs)
	if (locale === "de") return de_deposit_error_portfolio_not_ready(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_portfolio_not_ready(inputs)
	if (locale === "tr") return tr_deposit_error_portfolio_not_ready(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_portfolio_not_ready(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_portfolio_not_ready(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_portfolio_not_ready(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_portfolio_not_ready(inputs)
	return es_419_deposit_error_portfolio_not_ready(inputs)
});